import React from "react";
import { useState } from "react";
import { Form } from "react-bootstrap";
import Spinner from "react-bootstrap/Spinner";
import axios from "../../../api/axios";
import Cookies from "universal-cookie";
import ColorPicker from "../../../utils/ColorPicker";
import { useEffect } from "react";
import { Checkbox, FormControlLabel } from "@mui/material";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
const cookies = new Cookies();
const RegisterYourCompany = ({ handleClose }) => {
  const [showAlert, setShowAlert] = useState("");
  const [errMsg, setErrMsg] = useState("");
  const [showLoader] = useState(false);
  const [validated, setValidated] = useState(false);
  const [color, setColor] = useState("#000000");
  const [phoneIsValid, setPhoneIsValid] = useState(false);
  const options = ["Construction", "Ag", "Transpo", "Lifts"];
  const [companyData, setCompanyData] = useState({
    name: "",
    email: "",
    contact_number: "",
    address: "",
    referring_vendor_account: "",
    logo: "",
    theme_color: "",
    is_active: false,
    equipment_category: "",
  });
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  const handleClose2 = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
    setOpen2(false);
  };
  useEffect(() => {
    setCompanyData((prevFormData) => ({
      ...prevFormData,
      theme_color: color,
    }));
  }, [color]);

  useEffect(() => {
    const phoneRegex = /^\(\d{3}\)-\d{3}-\d{4}$/;
    if (
      companyData.contact_number &&
      phoneRegex.test(companyData.contact_number)
    ) {
      setPhoneIsValid(true);
    } else {
      setPhoneIsValid(false);
    }
  }, [companyData.contact_number]);

  const handleSignup = (e) => {
    e.preventDefault();
    console.log(color);
    const form = e.currentTarget;
    if (form.checkValidity() === false || !phoneIsValid) {
      e.stopPropagation();
      setValidated(true);
    } else {
      setValidated(false);
      setShowAlert("");
      setErrMsg("");
      let body = { ...companyData };
      body.contact_number = companyData.contact_number
        ? "+1" + companyData.contact_number.replace(/[^0-9]/g, "")
        : "";
      axios
        .post("lender/create-company/", body, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${cookies.get("access")}`,
          },
          withCredentials: true,
        })
        .then((res) => {
          handleClose();
        })
        .catch((err) => {
          if (err?.response?.data?.email) {
            setErrMsg(err?.response?.data?.email);
            setOpen(true);
          } else if (err?.response?.data?.name) {
            setErrMsg(err?.response?.data?.name);
            setOpen(true);
          } else if (err?.response?.data?.logo) {
            setErrMsg(err?.response?.data?.logo);
            setOpen(true);
          } else {
            setErrMsg("Server Error");
            setOpen(true);
          }
        });
    }
  };

  function formatNumber(sanitizedValue) {
    // If empty, return empty string to show placeholder
    if (!sanitizedValue) return "";

    // Remove any existing dashes and parentheses
    const digits = sanitizedValue.replace(/[^0-9]/g, "");

    // Format the number with parentheses and dashes
    if (digits.length <= 3) {
      return `(${digits}`;
    } else if (digits.length <= 6) {
      return `(${digits.slice(0, 3)})-${digits.slice(3)}`;
    } else {
      return `(${digits.slice(0, 3)})-${digits.slice(3, 6)}-${digits.slice(
        6,
        10
      )}`;
    }
  }

  const HandleCompanyPhoneChange = (e) => {
    let value = e.target.value;
    // Only allow numbers, dashes, and parentheses
    const sanitizedValue = value.replace(/[^0-9-()]/g, "");

    // Remove all non-digits for length check
    const digitsOnly = sanitizedValue.replace(/[^0-9]/g, "");

    if (digitsOnly.length <= 10) {
      let formatted = formatNumber(digitsOnly);
      setCompanyData((prevFormData) => ({
        ...prevFormData,
        contact_number: formatted,
      }));
    }
  };

  // Handle focus to show placeholder
  const handleFocus = (e) => {
    if (!companyData.contact_number) {
      e.target.placeholder = "(___)-___-____";
    }
  };

  // Handle blur to maintain formatting
  const handleBlur = (e) => {
    if (!companyData.contact_number) {
      e.target.placeholder = "(___)-___-____";
    }
  };

  const handleFileClick = (event) => {
    event.target.value = null;
  };

  const handleColorChange = (event) => {
    let value = event.target.value;
    if (event.target.type === "text") {
      if (!value.startsWith("#")) {
        value = "#" + value;
      }
      if (value.length > 7) {
        value = value.substring(0, 7);
      }
    }
    setColor(value);
  };
  return (
    <>
      {errMsg && (
        <Snackbar
          open={open}
          autoHideDuration={6000}
          onClose={handleClose2}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          <Alert
            onClose={handleClose2}
            severity="error"
            variant="filled"
            sx={{ width: "100%" }}
          >
            {errMsg}
          </Alert>
        </Snackbar>
      )}
      {showAlert && (
        <Snackbar
          open={open2}
          autoHideDuration={6000}
          onClose={handleClose2}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          <Alert
            onClose={handleClose2}
            severity="success"
            variant="filled"
            sx={{ width: "100%" }}
          >
            {showAlert}
          </Alert>
        </Snackbar>
      )}
      <div className="container mt-2 p-lg-5 p-md-5 p-4">
        <Form
          noValidate
          validated={validated}
          className=""
          onSubmit={handleSignup}
        >
          <h4 className="mb-4">Register Your Company</h4>
          <Form.Group
            className="mb-3 mt-2"
            controlId="exampleFormModel.ControlInput1"
          >
            <Form.Label>Company Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="name"
              name={companyData.name}
              value={companyData.name}
              onChange={(e) =>
                setCompanyData((prevFormData) => ({
                  ...prevFormData,
                  name: e.target.value,
                }))
              }
              pattern="^.{3,}$"
              required
            />
            <Form.Control.Feedback type="invalid">
              Please provide a valid name.
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group
            className="mb-3 mt-2"
            controlId="exampleFormModel.ControlInput2"
          >
            <Form.Label>Email Address</Form.Label>
            <Form.Control
              type="email"
              placeholder="email"
              value={companyData.email}
              name={companyData.email}
              onChange={(e) =>
                setCompanyData((prevFormData) => ({
                  ...prevFormData,
                  email: e.target.value,
                }))
              }
              required
            />
            <Form.Control.Feedback type="invalid">
              Please provide a valid email.
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group
            className="mb-3 mt-2"
            controlId="exampleFormModel.ControlInput3"
          >
            <Form.Label>Address</Form.Label>
            <Form.Control
              placeholder="Enter address"
              type="text"
              autoComplete="off"
              className="form-control"
              value={companyData.address}
              name={companyData.address}
              onChange={(e) =>
                setCompanyData((prevFormData) => ({
                  ...prevFormData,
                  address: e.target.value,
                }))
              }
              aria-describedby="uidnote"
              required
            />
            <Form.Control.Feedback type="invalid">
              Please provide a valid address name.
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group
            className="mb-3 mt-2"
            controlId="exampleFormModel.ControlInput4"
          >
            <Form.Label>Phone Number</Form.Label>
            <Form.Control
              type="tel"
              inputMode="numeric"
              placeholder="(555)-555-5555"
              name={companyData.contact_number}
              value={companyData.contact_number}
              onChange={HandleCompanyPhoneChange}
              onFocus={handleFocus}
              onBlur={handleBlur}
              isInvalid={validated && !phoneIsValid}
              required
            />
            <Form.Control.Feedback type="invalid">
              Please provide a valid US phone number e.g. (234)-567-8900
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group
            className="mb-3 mt-2"
            controlId="exampleFormModel.ControlInput1"
          >
            <Form.Label>Vendor ID</Form.Label>
            <Form.Control
              type="text"
              placeholder="Id"
              name={companyData.referring_vendor_account}
              value={companyData.referring_vendor_account}
              onChange={(e) =>
                setCompanyData((prevFormData) => ({
                  ...prevFormData,
                  referring_vendor_account: e.target.value,
                }))
              }
              pattern="^.{3,}$"
              required
            />
            <Form.Control.Feedback type="invalid">
              Please provide a valid Id.
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group
            className="mb-3 mt-2"
            controlId="exampleFormModel.ControlInput5"
          >
            <Form.Label>Logo</Form.Label>
            <Form.Control
              type="file"
              accept="image/*"
              onChange={(e) =>
                setCompanyData((prevFormData) => ({
                  ...prevFormData,
                  logo: e.target.files[0],
                }))
              }
              onClick={handleFileClick}
              required
            />
            <Form.Control.Feedback type="invalid">
              Please provide an image file
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group
            className="mb-3 mt-2"
            controlId="exampleFormModel.ControlInput6"
          >
            <Form.Label>Color Picker</Form.Label>
            <ColorPicker
              color={color}
              setColor={setColor}
              edit2={true}
              required={true}
            />
            <Form.Control
              type="text"
              style={{ display: "none" }}
              value={color}
              onChange={handleColorChange}
              required
              pattern="^#([0-9a-fA-F]{6})$"
            />
            <Form.Control.Feedback type="invalid">
              Please provide a valid hex code.
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group
            className="mb-3 mt-2"
            controlId="exampleFormModel.ControlInput4"
          >
            <Form.Label className="Email" style={{ float: "left" }}>
              Equipment Category:
            </Form.Label>
            <Form.Control
              as="select"
              type="select"
              name="payment_method"
              onChange={(e) =>
                setCompanyData((prevFormData) => ({
                  ...prevFormData,
                  equipment_category: e.target.value,
                }))
              }
              value={companyData.equipment_category}
            >
              <option value="">Select an option</option>
              {options.map((option, index) => (
                <option key={index} value={option}>
                  {option}
                </option>
              ))}
            </Form.Control>
            <Form.Control.Feedback type="invalid">
              Please choose a valid option.
            </Form.Control.Feedback>
          </Form.Group>
          <div>
            <Form.Group>
              <FormControlLabel
                control={<Checkbox />}
                label="Activate"
                className="my-2"
                checked={companyData.is_active}
                onChange={(e) =>
                  setCompanyData((prevFormData) => ({
                    ...prevFormData,
                    is_active: e.target.checked,
                  }))
                }
              />
            </Form.Group>
          </div>
          <div className="text-center">
            <button className="btn btn-dark  px-5" type="submit">
              {showLoader ? (
                <Spinner style={{ width: "1.4rem", height: "1.4rem" }} />
              ) : (
                "Register"
              )}
            </button>
          </div>
        </Form>
      </div>
    </>
  );
};

export default RegisterYourCompany;
